import { render, staticRenderFns } from "./HMChat.vue?vue&type=template&id=6f72e385&"
import script from "./HMChat.vue?vue&type=script&lang=js&"
export * from "./HMChat.vue?vue&type=script&lang=js&"
import style0 from "./HMChat.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports